import { all } from 'redux-saga/effects';
import addSubscriptionSaga from './watchers/addSubscriptionSaga';
import getSubscriptionsSaga from './watchers/getSubscriptionsSaga';

function* competencesSaga() {
  yield all([addSubscriptionSaga(), getSubscriptionsSaga()]);
}

export default competencesSaga;
